import { api } from './api';
import { News } from '../types/api.types';

export const newsApi = {
    getAll: (): Promise<News[]> =>
        api.get('/site/news').then(res => res.data),

    getByStatus: (status: string): Promise<News[]> =>
        api.get(`/site/news/status/${status}`).then(res => res.data),

    getLatest: (): Promise<News[]> =>
        api.get('/site/news/latest').then(res => res.data),

    getById: (id: number): Promise<News> =>
        api.get(`/site/news/${id}`).then(res => res.data),

    getAllAdmin: (): Promise<News[]> =>
        api.get('/admin/news').then(res => res.data),

    getByIdAdmin: (id: number): Promise<News> =>
        api.get(`/admin/news/${id}`).then(res => res.data),

    create: (data: Partial<News>): Promise<News> =>
        api.post('/admin/news', data).then(res => res.data),

    update: (id: number, data: Partial<News>): Promise<News> =>
        api.put(`/admin/news/${id}`, data).then(res => res.data),

    delete: (id: number): Promise<void> =>
        api.delete(`/admin/news/${id}`),

    uploadImage: (newsId: number, file: File): Promise<News> => {
        const formData = new FormData();
        formData.append('file', file);
        return api.post(`/admin/news/${newsId}/images`, formData, {
            headers: { 'Content-Type': 'multipart/form-data' }
        }).then(res => res.data);
    },

    deleteImage: (newsId: number, imageKey: string): Promise<News> =>
        api.delete(`/admin/news/${newsId}/images?imageKey=${imageKey}`).then(res => res.data),
};